export default "__VITE_ASSET__BRPXpIPj__"